import getBreakpointByDeviceMode from './get-breakpoint-by-device-mode';
import getResponsiveClassValue from './get-responsive-class-value';

const getCurrentClassValue = ({ element, className }) => {
  const breakpoint = getBreakpointByDeviceMode();
  return getResponsiveClassValue({ element, className, breakpoint });
};

export default getCurrentClassValue;
